// extracted by mini-css-extract-plugin
export default {"text-area-input":"TextAreaInput_text-area-input__pHMfs"};